<script lang="ts">
export let graphData:any;

</script>

<p class="fine-print"></p>
<div class="graph">
    <div class="grid-lines mid-y"></div>
    <div class="grid-lines quarter-y"></div>
    <div class="grid-lines three-quarter-y"></div>
    {#each graphData as coords }
        <div class="data-point" style="{'top: calc(' + (100 - coords.x) + '% - 2px); left: calc(' + (coords.y) + '% - 2px);'}"></div>
    {/each}
</div>

<style>
.graph {
    position: relative;
    /* top: 0; */
    /* left: 0; */
    width: calc(100% - 2rem);
    height: 20vh;
    background-color: var(--background);
    z-index: 3;
    border: 1px dotted var(--background-offset);

}
.grid-lines {
    position: absolute;
    height: 0;
    border-bottom: 1px dotted var(--background-offset);
    width: 100%;

}
.mid-y {
    top: calc(50% - .03rem);
}
.quarter-y {
    top: calc(25% - .03rem);
}
.three-quarter-y {
    top: calc(75% - .03rem);
}
.data-point {
    position: absolute;
    width: 4px;
    height: 4px;
    border-radius: 4px;
    background-color: var(--text);
}

</style>